var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-header",attrs:{"data-aos":"zoom-in"}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("@/assets/underline.svg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }